import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlignRightLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.5 16.238C2.5 14.5435 3.87356 13.1699 5.56811 13.1699H15.2951C16.9896 13.1699 18.3632 14.5435 18.3632 16.238V18.3041C18.3632 19.9986 16.9896 21.3722 15.2951 21.3722H5.56811C3.87356 21.3722 2.5 19.9986 2.5 18.3041V16.238ZM5.56811 14.6699C4.70198 14.6699 4 15.3719 4 16.238V18.3041C4 19.1702 4.70198 19.8722 5.56811 19.8722H15.2951C16.1612 19.8722 16.8632 19.1702 16.8632 18.3041V16.238C16.8632 15.3719 16.1612 14.6699 15.2951 14.6699H5.56811Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.28906 5.69506C7.28906 4.00051 8.66262 2.62695 10.3572 2.62695H15.2961C16.9906 2.62695 18.3642 4.00051 18.3642 5.69506V7.76111C18.3642 9.45566 16.9906 10.8292 15.2961 10.8292H10.3572C8.66262 10.8292 7.28906 9.45566 7.28906 7.76111V5.69506ZM10.3572 4.12695C9.49104 4.12695 8.78906 4.82894 8.78906 5.69506V7.76111C8.78906 8.62723 9.49104 9.32921 10.3572 9.32921H15.2961C16.1622 9.32921 16.8642 8.62723 16.8642 7.76111V5.69506C16.8642 4.82894 16.1622 4.12695 15.2961 4.12695H10.3572Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.25 2.33984C21.6642 2.33984 22 2.67563 22 3.08984V20.9091C22 21.3233 21.6642 21.6591 21.25 21.6591C20.8358 21.6591 20.5 21.3233 20.5 20.9091V3.08984C20.5 2.67563 20.8358 2.33984 21.25 2.33984Z",
			fill: "currentColor"
		})
	]
});
export default SvgAlignRightLine;
